var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { MovieStatusEnum } from "../types/Movie";
import { useRef, useEffect } from "react";
import { focusManager } from "./Focus";
export var handleOnKeyDown = function (e, action) {
    if (e.keyCode === 13 || e.keyCode === 66) {
        e.preventDefault();
        // e.stopPropagation();
        action();
    }
};
export var isEpisodePlayable = function (episode) {
    return (episode.status !== MovieStatusEnum.CS &&
        episode.status !== MovieStatusEnum.HI);
};
export var hasPlayableEpisodes = function (episodes) {
    var _a;
    return (_a = episodes === null || episodes === void 0 ? void 0 : episodes.some(isEpisodePlayable)) !== null && _a !== void 0 ? _a : false;
};
export var getFirstPlayableEpisode = function (episodes) {
    return episodes === null || episodes === void 0 ? void 0 : episodes.find(isEpisodePlayable);
};
export var getModalText = function (type, t) {
    if (type === "buy") {
        return t("buy_movie_modal.title");
    }
    return t("coming_soon_modal." + type);
};
export var onMoviePress = function (movie) {
    var isContentComingSoon = movie.status === MovieStatusEnum.CS;
    var hasPlayableEpisode = hasPlayableEpisodes(movie.episodes);
    var isSeriesComingSoon = movie.movieType === "series" && movie.episodes && !hasPlayableEpisode;
    if (isContentComingSoon || isSeriesComingSoon) {
        return {
            type: "modal",
            modalType: movie.movieType === "series" ? "series" : "movie",
        };
    }
    if (movie.type === "EST" && !movie.bought) {
        return { type: "modal", modalType: "buy" };
    }
    return { type: "navigate", slug: movie.slug };
};
export var onEpisodePress = function (episode, slug, navigate) {
    return navigate("watch", { slug: slug, episode: episode.id });
};
export var chunkArray = function (arr, size) {
    var result = [];
    for (var i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
};
export var getIdForSTB = function (key, paramName) {
    var stored = localStorage.getItem(key);
    if (stored)
        return stored;
    var paramValue = new URLSearchParams(window.location.search).get(paramName);
    if (paramValue) {
        localStorage.setItem(key, paramValue);
        return paramValue;
    }
    return null;
};
var isStoredIdStale = function (key, paramName) {
    var stored = localStorage.getItem(key);
    var paramValue = new URLSearchParams(window.location.search).get(paramName);
    return !!stored && !!paramValue && stored !== paramValue;
};
export var isSTBSessionStale = function () {
    return (isStoredIdStale("accountId", "user_id") ||
        isStoredIdStale("stbId", "stb_id"));
};
export var clearIdsForSTB = function () {
    localStorage.removeItem("accountId");
    localStorage.removeItem("stbId");
};
export var useFocusable = function (_a) {
    var group = _a.group, index = _a.index, id = _a.id, direction = _a.direction, onKeyDown = _a.onKeyDown, onKeyBack = _a.onKeyBack;
    var nodeRef = useRef(null);
    var resolvedId = id !== null && id !== void 0 ? id : "item-" + group + "-" + index;
    // Keep callbacks in refs so registration always has fresh references
    var onKeyDownRef = useRef(onKeyDown);
    var onKeyBackRef = useRef(onKeyBack);
    onKeyDownRef.current = onKeyDown;
    onKeyBackRef.current = onKeyBack;
    useEffect(function () {
        if (nodeRef.current) {
            focusManager.register(group, index, resolvedId, nodeRef.current, direction, function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_a = onKeyDownRef.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArrays([onKeyDownRef], args));
            }, function () { var _a; return (_a = onKeyBackRef.current) === null || _a === void 0 ? void 0 : _a.call(onKeyBackRef); });
        }
        return function () {
            focusManager.unregister(group, resolvedId);
        };
    }, [group, index, resolvedId, direction]);
    return nodeRef;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/Helpers.ts
// module id = 2
// module chunks = 1